(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-contact-professional"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.bb-contact-pro').forEach(function(contact){
  var headParam=new URLSearchParams(window.location.search).get('contact_head');
  var head=headParam||'3';
  if(head==='1'||head==='2'||head==='3'||head==='4'||head==='5'||head==='6'){
    contact.classList.add('bb-contact-pro--head-'+head);
    var switcher=contact.querySelector('.bb-contact-pro__preview-switch');
    if(switcher&&headParam){
      switcher.hidden=false;
      switcher.querySelectorAll('[data-contact-head]').forEach(function(link){
        var target=new URL(window.location.href);
        target.searchParams.set('contact_head',link.getAttribute('data-contact-head'));
        target.searchParams.delete('oseid');
        link.href=target.pathname+target.search;
      });
      var active=switcher.querySelector('[data-contact-head="'+head+'"]');
      if(active)active.setAttribute('aria-current','page');
    }
    if(head==='3'){
      var panelParam=new URLSearchParams(window.location.search).get('contact_panel');
      var panel=panelParam||'3';
      if(panel!=='1'&&panel!=='2'&&panel!=='3')panel='3';
      contact.classList.add('bb-contact-pro--panel-'+panel);
      var panelSwitcher=contact.querySelector('.bb-contact-pro__panel-switch');
      if(panelSwitcher&&panelParam){
        panelSwitcher.hidden=false;
        panelSwitcher.querySelectorAll('[data-contact-panel]').forEach(function(link){
          var panelTarget=new URL(window.location.href);
          panelTarget.searchParams.set('contact_head','3');
          panelTarget.searchParams.set('contact_panel',link.getAttribute('data-contact-panel'));
          panelTarget.searchParams.delete('oseid');
          link.href=panelTarget.pathname+panelTarget.search;
        });
        var activePanel=panelSwitcher.querySelector('[data-contact-panel="'+panel+'"]');
        if(activePanel)activePanel.setAttribute('aria-current','page');
      }
    }
  }
});

document.querySelectorAll('.bb-contact-upload[data-error-heading]').forEach(function (container) {
  if (container.dataset.errorSummaryLocalized) return;
  container.dataset.errorSummaryLocalized = 'true';
  var heading = container.dataset.errorHeading;
  function translateSummary() {
    container.querySelectorAll('.gfb__error-summary').forEach(function (summary) {
      summary.childNodes.forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var translated = node.nodeValue.replace(/^There (?:are|is) \d+ problems? with your submission:\s*/, heading + ' ');
        if (translated !== node.nodeValue) node.nodeValue = translated;
      });
    });
  }
  translateSummary();
  new MutationObserver(translateSummary).observe(container, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

document.querySelectorAll('.bb-contact-upload').forEach(function (container) {
  var topic = new URLSearchParams(window.location.search).get('anliegen');
  if (!topic && window.location.pathname === '/pages/reparatur-anfragen') topic = 'reparatur';
  var topicMap = { geraeteankauf: 'Geräteankauf', garantie: 'Garantie', reparatur: 'Reparaturservice', transport: 'Transportservice', kuechenmontage: 'Küchenmontage', moebelaufbau: 'Möbelaufbau', wohnungsaufloesung: 'Wohnungsauflösung', renovierung: 'Renovierungsarbeiten', grundreinigung: 'Grundreinigung' };
  if (!topicMap[topic] && document.referrer) {
    try {
      var previous = new URL(document.referrer);
      if (previous.origin === window.location.origin) {
        if (previous.pathname === '/pages/geraet-verkaufen') topic = 'geraeteankauf';
        if (previous.pathname === '/pages/garantie') topic = 'garantie';
        if (previous.pathname === '/pages/reparaturservice') topic = 'reparatur';
        if (previous.pathname === '/pages/transportservice') topic = 'transport';
        if (previous.pathname === '/pages/kuchenmontage') topic = 'kuechenmontage';
        if (previous.pathname === '/pages/mobelaufbau') topic = 'moebelaufbau';
        if (previous.pathname === '/pages/wohnungsauflosung') topic = 'wohnungsaufloesung';
        if (previous.pathname === '/pages/renovierungsarbeiten') topic = 'renovierung';
        if (previous.pathname === '/pages/grundreinigung') topic = 'grundreinigung';
      }
    } catch (error) {}
  }
  var intended = topicMap[topic];
  if (!intended) return;
  var observer = new MutationObserver(selectTopic);
  function selectTopic() {
    var field = container.querySelector('.globo-formbuilder[data-gfb-draft-bound="1"] select[name="select-1"]');
    if (!field || !Array.from(field.options).some(function (option) { return option.value === intended; })) return;
    observer.disconnect();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var currentField = container.querySelector('select[name="select-1"]');
        if (!currentField) return;
        currentField.value = intended;
        currentField.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  document.addEventListener('globo.formbuilder.scripts.loaded', selectTopic, { once: true });
  observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-gfb-draft-bound'] });
  selectTopic();
});


document.querySelectorAll('.bb-contact-upload').forEach(function (container) {
  function enhanceContactInputs() {
    var name = container.querySelector('.globo-formbuilder input[name="text"]');
    var email = container.querySelector('.globo-formbuilder input[name="email"]');
    var phone = container.querySelector('.globo-formbuilder input[name="text-1"]');
    if (name) name.setAttribute('autocomplete', 'name');
    if (email) {
      email.setAttribute('inputmode', 'email');
      email.setAttribute('autocomplete', 'email');
      email.setAttribute('autocapitalize', 'none');
      email.setAttribute('spellcheck', 'false');
    }
    if (phone) {
      phone.setAttribute('inputmode', 'tel');
      phone.setAttribute('autocomplete', 'tel');
      var phoneLabel = phone.labels && phone.labels[0];
      if (phoneLabel && !phoneLabel.querySelector('.bb-contact-optional')) {
        var optional = document.createElement('span');
        optional.className = 'bb-contact-optional';
        optional.textContent = ' (optional)';
        phoneLabel.appendChild(optional);
      }
    }
    var message = container.querySelector('.globo-formbuilder textarea[name="textarea-1"]');
    if (message) {
      var helpId = message.id + '-bb-help';
      if (!container.querySelector('[id="' + helpId + '"]')) {
        var help = document.createElement('p');
        help.id = helpId;
        help.className = 'bb-contact-message-help';
        help.textContent = 'Bitte nennen Sie Ihr Gerätemodell oder Ihre Bestellnummer, falls vorhanden, und beschreiben Sie Ihr Anliegen.';
        message.parentElement.insertAdjacentElement('afterend', help);
      }
      var describedBy = (message.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (describedBy.indexOf(helpId) === -1) {
        describedBy.push(helpId);
        message.setAttribute('aria-describedby', describedBy.join(' '));
      }
    }
  }
  enhanceContactInputs();
  document.addEventListener('globo.formbuilder.scripts.loaded', enhanceContactInputs);
  new MutationObserver(enhanceContactInputs).observe(container, { childList: true, subtree: true });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-product-detail-modern"] && !Shopify.designMode) return;
  try {
    (function () {
  function labelDeviceReviews() {
    var productRoot = document.querySelector('[data-bb-device-reviews-label]');
    if (!productRoot) return;
    var label = productRoot.dataset.bbDeviceReviewsLabel;
    document.querySelectorAll('.jdgm-all-reviews-widget').forEach(function (widget) {
      if (widget.dataset.bbReviewLabelReady) return;
      widget.dataset.bbReviewLabelReady = 'true';
      function updateLabel() {
        widget.querySelectorAll('.jdgm-row-readmore a[href*="popup-primary-content"]').forEach(function (link) {
          if (link.textContent !== label) link.textContent = label;
        });
      }
      updateLabel();
      new MutationObserver(updateLabel).observe(widget, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelDeviceReviews, { once: true });
  } else {
    labelDeviceReviews();
  }
  document.addEventListener('shopify:section:load', labelDeviceReviews);
})();

(function () {
  var productRoot = document.querySelector('[data-bb-review-dialog-label]');
  if (!productRoot) return;
  function prepareReviewDialog(popup) {
    if (popup.dataset.bbDialogReady) return;
    popup.dataset.bbDialogReady = 'true';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', productRoot.dataset.bbReviewDialogLabel);
    function labelCloseButtons() {
      popup.querySelectorAll('.jm-mfp-close').forEach(function (button) {
        button.setAttribute('aria-label', productRoot.dataset.bbReviewCloseLabel);
        button.setAttribute('title', productRoot.dataset.bbReviewCloseLabel);
      });
    }
    labelCloseButtons();
    new MutationObserver(labelCloseButtons).observe(popup, { childList: true, subtree: true });
    popup.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.from(popup.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]')).filter(function (element) {
        return element.tabIndex >= 0 && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
      });
      if (!controls.length) return;
      var first = controls[0];
      var last = controls[controls.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || active === popup)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || active === popup)) {
        event.preventDefault();
        first.focus();
      }
    });
  }
  document.querySelectorAll('.jm-mfp-wrap.jdgm-rev-popup').forEach(prepareReviewDialog);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.matches('.jm-mfp-wrap.jdgm-rev-popup')) prepareReviewDialog(node);
      });
    });
  }).observe(document.body, { childList: true });
})();

document.querySelectorAll('[data-bb-product-detail]').forEach(function (root) {
  if (root.dataset.bbGalleryReady) return;
  root.dataset.bbGalleryReady = 'true';
  var image = root.querySelector('.bb-pd__main-image');
  var counter = root.querySelector('.bb-pd__counter');
  var slides = Array.from(root.querySelectorAll('[data-bb-slide]'));
  var thumbs = Array.from(root.querySelectorAll('[data-bb-thumb]'));
  var rail = root.querySelector('.bb-pd__rail');
  var active = 0;
  if (!image || !slides.length) return;
  var dialog = root.querySelector('[data-bb-zoom]');
  var opener = root.querySelector('[data-bb-zoom-open]');
  var fullImage = root.querySelector('[data-bb-zoom-image]');
  var stage = root.querySelector('[data-bb-zoom-stage]');
  var zoomToggle = root.querySelector('[data-bb-zoom-toggle]');
  var previousOverflow;
  function resetZoom() {
    stage.classList.remove('is-zoomed');
    stage.scrollTop = 0;
    stage.scrollLeft = 0;
    zoomToggle.setAttribute('aria-pressed', 'false');
    zoomToggle.textContent = 'Detail vergrößern';
  }
  function updateDialog() {
    resetZoom();
    fullImage.src = slides[active].dataset.fullImage;
    fullImage.alt = slides[active].dataset.alt;
    root.querySelector('[data-bb-zoom-counter]').textContent = 'Bild ' + (active + 1) + ' von ' + slides.length;
  }
  function select(index) {
    active = (index + slides.length) % slides.length;
    image.srcset = '';
    image.src = slides[active].dataset.image;
    image.alt = slides[active].dataset.alt;
    thumbs.forEach(function (thumb) {
      var selected = Number(thumb.dataset.index) === active;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-current', String(selected));
    });
    if (rail && thumbs[active]) {
      var railBounds = rail.getBoundingClientRect();
      var thumbBounds = thumbs[active].getBoundingClientRect();
      if (thumbBounds.left < railBounds.left + 5) {
        rail.scrollLeft += thumbBounds.left - railBounds.left - 5;
      } else if (thumbBounds.right > railBounds.right - 5) {
        rail.scrollLeft += thumbBounds.right - railBounds.right + 5;
      }
    }
    if (counter) counter.textContent = (active + 1) + ' / ' + slides.length;
    if (dialog && dialog.open) updateDialog();
  }
  thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { select(Number(thumb.dataset.index)); }); });
  var previous = root.querySelector('[data-bb-prev]');
  var next = root.querySelector('[data-bb-next]');
  if (previous) previous.addEventListener('click', function () { select(active - 1); });
  if (next) next.addEventListener('click', function () { select(active + 1); });
  if (!dialog || !opener) return;
  opener.addEventListener('click', function () {
    if (dialog.open) return;
    updateDialog();
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  });
  root.querySelector('[data-bb-zoom-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () {
    document.documentElement.style.overflow = previousOverflow;
    resetZoom();
    opener.focus({ preventScroll: true });
  });
  root.querySelector('[data-bb-zoom-prev]').addEventListener('click', function () { select(active - 1); });
  root.querySelector('[data-bb-zoom-next]').addEventListener('click', function () { select(active + 1); });
  zoomToggle.addEventListener('click', function () {
    var zoomed = stage.classList.toggle('is-zoomed');
    zoomToggle.setAttribute('aria-pressed', String(zoomed));
    zoomToggle.textContent = zoomed ? 'Ganzes Bild anzeigen' : 'Detail vergrößern';
  });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      var focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), [tabindex="0"]'));
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
      return;
    }
    if (stage.classList.contains('is-zoomed') && event.target === stage) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      select(active + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
  if (slides.length === 1) {
    root.querySelector('[data-bb-zoom-prev]').disabled = true;
    root.querySelector('[data-bb-zoom-next]').disabled = true;
  }
});
  } catch(e) { console.error(e); }
})();

})();
